<template>
  <div class="pr-2 field-info " :class="{ 'disabled-field' : !fieldData.is_enabled }">
    <div class="field-label w-100 align-top d-inline-flex">
      <label :for="labelFor" :class="{ 'align-top': true, 'important': (this.fieldData.field_type === 'radio_single_VIN' ? 'important' : '') }"><span v-html="fieldData.label"></span><span v-if="fieldData.is_required" class="star">*</span>
      </label>
      <button
      v-if="fieldData.help_text"
      :id="'tooltip_icon_'+fieldData.field_name"
      :ref="'tooltip_icon_'+fieldData.field_name"
      @keydown.enter.prevent.stop="toggleCollapse"
      @keydown.space.prevent.stop="toggleCollapse"
      @click="toggleCollapse"
      :data-target="'#tooltip_'+fieldData.field_name"
      class="align-top mx-2"
      type="button"
      tabindex="0">
        <icon name="info-circle" scale="1.0" class="field-tooltip-icon align-top"></icon>
      </button>
    </div>
    <div v-if="fieldData.help_text && fieldData.help_text != ''"
    class="field-tooltip-text d-block">
      <div
      :id="'tooltip_'+fieldData.field_name"
      :ref="'tooltip_'+fieldData.field_name"
      :data-target="'#tooltip_icon_'+fieldData.field_name"
      class="collapse form-row bg-light rounded mx-0 mb-2 mr-3 tip-custom">
        <div v-html="fieldData.help_text" class="col py-2 px-3 smaller-font-content"></div>
        <div class="col-1 my-auto">
          <button type="button" class="close" aria-label="Close" :id="'tooltipclose_'+fieldData.field_name" :data-target="'#tooltip_'+fieldData.field_name" :ref="'tooltip_icon_'+fieldData.field_name" @keydown.enter.prevent.stop="toggleCollapse"
      @keydown.space.prevent.stop="toggleCollapse" @click="toggleCollapse">
            <span aria-hidden="true" :data-target="'#tooltip_'+fieldData.field_name"><span class="far fa-times-circle"></span></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uiHelpers } from '../../mixins/uiHelpers';

export default {
  mixins: [uiHelpers],
  props: ['fieldData'],
  computed: {
    labelFor() {
      return this.fieldData.field_name === 'QTE_BillPlan' ? this.fieldData.field_value : this.fieldData.field_name;
    },
  },
};
</script>

<style scoped lang="scss">
/**ToolTip CSS**/
.mw-90{
  max-width: 90%;
}
.tip-custom {
  overflow-y: hidden;
}
label {
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1rem;
  display: inline-block;
}

.field-info{
  line-height: 1rem;
}

.field-info > .field-label {
  display: inline-block;
  line-height: 1rem;
  font-weight: 600;
}

.field-info > .field-label > button > .field-tooltip-icon {
  display: inline-block;
  color: $var-field-tooltip-icon;
  line-height: 1rem;
  cursor: pointer;
}
.field-info > .field-label > button
{
    border: 0px !important;
    padding: 0px !important;
    background-color: white !important;
}
.important {
  color: #D00000;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/FieldInfo.vue?ec6fbd28